const ExpandCollapse = ({
  toggleAllAccordions,
  allAccordionsOpen,
  anyAccordionOpen,
  highlightDifferences,
  setHighlightDifferences,
}: {
  toggleAllAccordions: (isOpen: boolean) => void;
  allAccordionsOpen: boolean;
  anyAccordionOpen: boolean;
  highlightDifferences: boolean;
  setHighlightDifferences: (isDifference: boolean) => void;
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "24px 10px 24px 30px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          fontSize: 18,
          fontWeight: 600,
        }}
      >
        <div
          className="expand-all"
          style={{
            paddingRight: 16,
            borderRight: "3px solid #8A8A8A",
            color: !anyAccordionOpen
              ? "#1B54C2"
              : allAccordionsOpen
              ? "#8A8A8A "
              : "#1B54C2",
            cursor: !anyAccordionOpen
              ? "pointer"
              : allAccordionsOpen
              ? "not-allowed"
              : "pointer",
          }}
          onClick={() => toggleAllAccordions(true)}
        >
          Expand all
        </div>
        <div
          style={{
            paddingLeft: 16,
            color: anyAccordionOpen
              ? "#1B54C2"
              : !allAccordionsOpen
              ? "#8A8A8A "
              : "#1B54C2",
            cursor: anyAccordionOpen
              ? "pointer"
              : !allAccordionsOpen
              ? "not-allowed"
              : "pointer",
          }}
          onClick={() => toggleAllAccordions(false)}
        >
          Collapse all
        </div>
      </div>
      <div
        className="hide-for-small-only"
        style={{ display: "flex", alignItems: "center", fontSize: 18 }}
      >
        <input
          type="checkbox"
          checked={highlightDifferences}
          onChange={(e) => setHighlightDifferences(e.target.checked)}
          style={{ width: 18, height: 18 }}
        />
        <div style={{ paddingLeft: 4 }}>Highlight Differences</div>
      </div>
    </div>
  );
};

export default ExpandCollapse;
